import { PropertyMedia } from './PropertyMedia.ts';

const apiBaseUrl = import.meta.env.VITE_API_BASE_URL;

// Get all available images for a property
export const getPropertyMedia = async (
  propertyId: number,
): Promise<PropertyMedia[]> => {
  const response = await fetch(`${apiBaseUrl}/properties/${propertyId}/media`, {
    headers: {
      Accept: 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch property media: ${response.statusText}`);
  }

  return await response.json();
};
